import axiosInstance from './AxiosInstance';

const CompanyKycService = {
  // 1. CREATE COMPANY KYC
  createCompanyKyc: async (kycData) => {
    try {
      const response = await axiosInstance.post('/company-kyc', kycData);
      return {
        success: response.data.success,
        data: response.data.data.companyKyc,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create company KYC',
        errors: error.response?.data?.errors || []
      };
    }
  },

  // 2. GET ALL COMPANY KYC
  getAllCompanyKyc: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filters
      if (params.companyId) queryParams.append('companyId', params.companyId);
      if (params.branchId) queryParams.append('branchId', params.branchId);
      if (params.kycUserType) queryParams.append('kycUserType', params.kycUserType);
      if (params.isRequired !== undefined) queryParams.append('isRequired', params.isRequired);

      const response = await axiosInstance.get(`/company-kyc?${queryParams.toString()}`);
      return {
        success: response.data.success,
        data: response.data.data.data,
        pagination: response.data.data.pagination,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch company KYC',
        data: [],
        pagination: {}
      };
    }
  },

  // 3. GET KYC MASTER LIST
  getKycMasterList: async () => {
    try {
      const response = await axiosInstance.get('/company-kyc/kyc-master');
      return {
        success: response.data.success,
        data: response.data.data.kycMasters,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch KYC master list',
        data: []
      };
    }
  },

  // 4. GET COMPANY KYC BY ID
  getCompanyKycById: async (id) => {
    try {
      const response = await axiosInstance.get(`/company-kyc/${id}`);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch company KYC',
        data: null
      };
    }
  },

  // 5. UPDATE COMPANY KYC
  updateCompanyKyc: async (id, kycData) => {
    try {
      const response = await axiosInstance.put(`/company-kyc/${id}`, kycData);
      return {
        success: response.data.success,
        data: response.data.data.companyKyc,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update company KYC',
        errors: error.response?.data?.errors || []
      };
    }
  },

  // 6. DELETE COMPANY KYC
  deleteCompanyKyc: async (id) => {
    try {
      const response = await axiosInstance.delete(`/company-kyc/${id}`);
      return {
        success: response.data.success,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete company KYC'
      };
    }
  },

  // Legacy method names for backward compatibility
  getCompanyKyc: async (params = {}) => {
    return await CompanyKycService.getAllCompanyKyc(params);
  },

  createKycRequirement: async (kycData) => {
    return await CompanyKycService.createCompanyKyc(kycData);
  },

  updateKycRequirement: async (id, kycData) => {
    return await CompanyKycService.updateCompanyKyc(id, kycData);
  },

  deleteKycRequirement: async (id) => {
    return await CompanyKycService.deleteCompanyKyc(id);
  },

  getKycTypes: async () => {
    return await CompanyKycService.getKycMasterList();
  },

  // Helper method for company filtering
  getKycByCompany: async (companyId) => {
    return await CompanyKycService.getAllCompanyKyc({ companyId });
  },

  // Helper method for branch filtering
  getKycByBranch: async (branchId) => {
    return await CompanyKycService.getAllCompanyKyc({ branchId });
  },

  // Helper method for user type filtering
  getKycByUserType: async (kycUserType) => {
    return await CompanyKycService.getAllCompanyKyc({ kycUserType });
  },

  // Helper method for required KYC
  getRequiredKyc: async (companyId) => {
    return await CompanyKycService.getAllCompanyKyc({ companyId, isRequired: true });
  }
};

export default CompanyKycService;
